import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import {Img} from "../Img";
import {Heading} from "../Heading";

const LanguageSwitcher: React.FC = () => {
    const { i18n } = useTranslation();
    const [dropdownOpen, setDropdownOpen] = useState(false);

    const computedLanguages = [
        { code: "ru", label: i18n.language === "ru" ? "Русский" : "Russian" },
        { code: "en", label: "English" },
    ];

    const toggleDropdown = () => setDropdownOpen((prev) => !prev);

    const changeLanguage = (code: string) => {
        i18n.changeLanguage(code);
        setDropdownOpen(false);
    };

    const currentLanguage =
        computedLanguages.find((lang) => lang.code === i18n.language) || computedLanguages[0];

    return (
        <div className="relative inline-block">
            <div
                onClick={toggleDropdown}
                className="group flex items-center cursor-pointer select-none pb-0.5"
            >
                <div className={`w-[75px] h-[32px] rounded-l-[12px] px-2 flex items-center justify-center ${
                    dropdownOpen ? "bg-[#0000001F]" : "bg-[#E0E0E0] group-hover:opacity-80"
                }`}>
                    <Heading
                        size="desktop_body_s_bold"
                        className="text-[#191C30E5]"
                    >
                        {currentLanguage.label}
                    </Heading>
                </div>
                <div className="w-[2px]" />
                {/* Правая часть */}
                <div className={`w-[32px] h-[32px] rounded-r-[12px] px-2 flex items-center justify-center ${
                    dropdownOpen ? "bg-[#0000001F]" : "bg-[#E0E0E0] group-hover:opacity-80"
                }`}>
                    <Img src="/images/arrow_down_language.svg" />
                </div>
            </div>


            {dropdownOpen && (
                <div className="absolute top-full right-0 mt-2 w-[180px] h-[108px] bg-white border border-[#E0E0E0] rounded-[12px] p-2 flex flex-col gap-1 shadow-[0_25px_15px_rgba(0,0,0,0.03),0_11px_11px_rgba(0,0,0,0.04),0_3px_6px_rgba(0,0,0,0.05)] z-10">
                    {computedLanguages.map((lang) => {
                        const selected = lang.code === i18n.language;
                        return (

                            <div
                                key={lang.code}
                                className="flex items-center justify-between w-full h-[44px] py-[10px] px-2 gap-2.5 rounded-[8px] cursor-pointer hover:bg-gray-100"
                                onClick={() => changeLanguage(lang.code)}
                            >
                                <span>
                                    <Heading
                                        size="desktop_body_m">
                                        {lang.label}
                                    </Heading>
                                </span>
                                <div className="mr-[8px]">
                                    {selected ? (
                                        <div className="w-[24px] h-[24px] flex items-center justify-center rounded-full border-[6px] border-[#FFB800]">
                                            <div className="w-3 h-3 rounded-full bg-[#FFFFFF]" />
                                        </div>
                                    ) : (
                                        <div className="w-[24px] h-[24px] flex items-center justify-center rounded-full border-2 border-gray-400"></div>
                                    )}
                                </div>
                            </div>
                        );
                    })}
                </div>
            )}
        </div>
    );
};

export default LanguageSwitcher;
